<template>
  <div>
    <Addition v-if="isAddition">
      <template #field>{{ change.field.name }}</template>
      <h4 v-if="categoryName">
        {{ $t("message.common.category") }}:
        <span>{{ categoryName }}</span>
      </h4>
      <GmbServiceChangeItem
        :service="change.new_value"
        :change-type="change.type"
      />
    </Addition>
    <Removal v-else-if="isRemoval">
      <template #field>{{ change.field.name }}</template>
      <h4 v-if="categoryName">
        {{ $t("message.common.category") }}:
        <span>{{ categoryName }}</span>
      </h4>
      <GmbServiceChangeItem
        :service="change.old_value"
        :change-type="change.type"
      />
    </Removal>
    <Change v-else-if="isChange">
      <template #field>{{ change.field.name }}</template>
      <h4 v-if="categoryName" class="mb-2">
        {{ $t("message.common.category") }}:
        <span> {{ categoryName }}</span>
      </h4>
      <template #old>
        <GmbServiceChangeItem
          :service="change.old_value"
          :change-type="change.type"
        />
      </template>
      <template #new>
        <GmbServiceChangeItem
          highlighted
          :service="change.new_value"
          :change-type="change.type"
        />
      </template>
    </Change>
  </div>
</template>

<script>
import { EXTERNAL_CHANGES_TYPE } from "@/enums/external-changes";

import Addition from "@/components/ExternalChanges/general/Addition.vue";
import Removal from "@/components/ExternalChanges/general/Removal.vue";
import Change from "@/components/ExternalChanges/general/Change.vue";
import GmbServiceChangeItem from "@/components/ExternalChanges/helpers/GmbServiceChangeItem";

export default {
  name: "ServiceChange",
  props: {
    change: {
      type: Object,
      required: true
    }
  },
  components: { Addition, Removal, Change, GmbServiceChangeItem },

  computed: {
    currentLanguage() {
      return this.$i18n.locale;
    },
    isCurrentLanguageDifferentThanPl() {
      return this.currentLanguage !== "pl";
    },
    isAddition() {
      return (
        this.isChangeType(EXTERNAL_CHANGES_TYPE.ADDITION) &&
        !!this.change.new_value
      );
    },
    isRemoval() {
      return (
        this.isChangeType(EXTERNAL_CHANGES_TYPE.REMOVAL) &&
        !!this.change.old_value
      );
    },
    isChange() {
      return (
        this.isChangeType(EXTERNAL_CHANGES_TYPE.CHANGE) &&
        !!this.change.new_value &&
        !!this.change.old_value
      );
    },
    categoryName() {
      return this.getCategoryName();
    }
  },
  methods: {
    isChangeType(type) {
      return this.change && this.change.type === type;
    },
    getCategoryName() {
      if (this.change) {
        if (
          this.change.old_value &&
          this.change.old_value.gmb_category &&
          this.change.old_value.gmb_category.name
        ) {
          return this.isCurrentLanguageDifferentThanPl
            ? this.change.old_value.gmb_category.name_en
            : this.change.old_value.gmb_category.name;
        }
        if (
          this.change.new_value &&
          this.change.new_value.gmb_category &&
          this.change.new_value.gmb_category.name
        ) {
          return this.isCurrentLanguageDifferentThanPl
            ? this.change.new_value.gmb_category.name_en
            : this.change.new_value.gmb_category.name;
        }
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
h4 {
  @include font-size(14px);
  opacity: 0.6;
  font-weight: 400;

  span {
    font-weight: 500;
  }
}

.new-value {
  font-weight: bold;
}

.old-value {
  text-decoration: line-through;
}
</style>
